import {
  FC,
  useCallback,
  useMemo,
} from 'react';
import {
  FormControlLabel,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import {
  LocalizationProvider, TimePickerToolbar, TimePickerToolbarProps, TimeView,
} from '@mui/x-date-pickers';
import { Moment } from 'moment-timezone';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

import { LabelPlacement } from 'enum/LabelPlacement';

import './AppTimeInput.scss';

export const UTC = 'UTC';

interface IComponentProps {
  name?: string;
  required?: boolean;
  disabled?: boolean;
  formItemName: string;
  className?: string;
  onFieldChange?: (e: Moment | null) => void;
  hideSeconds?: boolean;
  hideMinutes?: boolean;
  labelPlacement?: LabelPlacement;
  timeZone?: string;
}

const AppTimeInput: FC<IComponentProps> = ({
  name,
  required = false,
  disabled = false,
  formItemName,
  onFieldChange,
  className = '',
  hideMinutes = false,
  hideSeconds = false,
  labelPlacement,
  timeZone,
}) => {
  const ctx = useFormContext();

  const views = useMemo(() => {
    const views = ['hours'];

    if (!hideSeconds) {
      views.push('seconds');
    }

    if (!hideMinutes) {
      views.push('minutes');
    }

    return views as TimeView[];
  }, [hideSeconds, hideMinutes]);

  const CustomToolbar = useCallback((props: TimePickerToolbarProps<Moment>) => {
    const { value } = props;
    return (
      <TimePickerToolbar {...props as any} value={value?.tz(timeZone || UTC)} />
    );
  }, [timeZone]);

  return (
    <Controller
      name={formItemName}
      control={ctx.control}
      render={({ field: { value, onChange, ...field } }) => {
        return (
          <FormControlLabel
            className={`app-input ${className}`}
            required={required}
            disabled={disabled}
            data-testid="from"
            control={(
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <MobileTimePicker
                  {...field}
                  ampm={false}
                  closeOnSelect
                  formatDensity="spacious"
                  timezone={timeZone}
                  onChange={onChange}
                  value={value}
                  onAccept={(e) => {
                    onFieldChange?.(e);
                  }}
                  views={views}
                  slots={{
                    toolbar: CustomToolbar,
                  }}
                />
              </LocalizationProvider>
          )}
            label={name || ''}
            labelPlacement={labelPlacement || LabelPlacement.TOP}
          />
        );
      }}
    />
  );
};

export default AppTimeInput;
